<template>
	<div id="color-workflow-notification-modal" class="modal-new hidden">
		<svg class="btn-close-modal" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
			<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			<path d="M0 0h24v24H0z" fill="none" />
		</svg>
		<span class="title">Non colour managed workflow</span>

		<p class="description" style="text-align: left">
			No Input or No Output Transform options will result in a non colour managed workflow. All tools in the app are optimised for ACEScct
			colour managed workflow. We strongly suggest using the appropriate ACES Input and Output Transforms for your camera for best results.
		</p>

		<div class="buttons-continer --single-item">
			<button type="button" class="modal-btn --primary" data-modal-action="accept-color-workflow">I understand</button>
		</div>

		<div class="option-container">
			<div class="switch switch-container">
				<input type="checkbox" name="do-not-show" />
				<span class="slider round"></span>
			</div>
			<span class="option-title">Do not show this message again</span>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.option-container {
	margin-top: 34px;
	> .switch {
		margin-left: initial;
	}
}
</style>
